import React from 'react';
import CaseAdditionalInformationPres from 'src/ui/features/Cases/presentational/CaseAdditionalInformationPres';
import intl from 'react-intl-universal';
import { withSnackbar } from 'notistack';
import Button from 'src/ui/library/Button';
import {
  saveCaseDetailWithCountryMappingId,
  fetchCountryFormDetail,
  saveQuickViewDetail,
  createQuickViewDetail,
} from 'src/services/cases.service';
import { transformFormValues } from 'src/helpers';
import classNames from 'classnames';
import Spinner from 'src/ui/library/Spinner/Spinner';

class CaseAdditionalInformationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.formQVData = {};
    this.qvDataLoaded = false;
  }

  state = {
    isEditable: false,
    showModal: false,
    isLoading: false,
  };

  internalTransformFormData = (someFormData, requestParams) => {
    const { formValues } = someFormData;
    const data = {
      entityId: this.props.caseId || this.props.casePowerAppsId,
      ...requestParams,
      ...transformFormValues(formValues),
      languageId: 1,
      pageSourceId: requestParams.sourceTableId,
    };
    return data;
  };

  handleCancel = () => {
    this.setState({
      showModal: false,
      isEditable: false,
    });

    this.props.updateAdditionalInfoFound({
      isAdditionalInfoSecExist: true,
      hasAdditionalInfo: true,
    });
  };

  handleSave = async () => {
    const { caseInfoData, additionalInfoData } = this.props;
    this.setState({ isLoading: true });

    const countryMappingData = {
      entityId: additionalInfoData.countryMappingFormDetails.case.createdId,
      caseId: caseInfoData.case.caseId,
    };
    const transformedQVData = this.internalTransformFormData(this.formQVData, additionalInfoData.countryMappingFormDetails);
    let combineQVData = {
      ...transformedQVData,
      countryName: caseInfoData.case.serviceCountry,
      caseType: caseInfoData.case.eyService,
      caseId: caseInfoData.case.caseId,
      entityId: additionalInfoData.countryMappingFormDetails.case.createdId,
    };
    if (this.props.newAdditionalInfoRecordId) {
      combineQVData.entityId = this.props.newAdditionalInfoRecordId;
    }
    const [caseDetailResult, qvDetailResult] = await Promise.all([
      saveCaseDetailWithCountryMappingId(countryMappingData),
      saveQuickViewDetail(combineQVData),
    ]);

    if (qvDetailResult && !qvDetailResult.error && caseDetailResult && !caseDetailResult.error) {
      // reload  qvformdetails
      const countryFormFetchResult = await fetchCountryFormDetail(caseInfoData.case.caseId);
      countryFormFetchResult.case &&
        countryFormFetchResult.case.pageElements &&
        countryFormFetchResult.case.pageElements.forEach(item => (item.numberOfColumns = item.numberOfColumns === null ? null : 2));

      this.props.updateAdditionalInfoData({
        isAdditionalInfoSecExist: true,
        hasAdditionalInfo: true,
        additionalInfoData: {
          countryMappingFormDetails: countryFormFetchResult,
        },
      });

      const { enqueueSnackbar } = this.props;
      this.setState({ showModal: false, isEditable: false, isLoading: false }, () => {
        enqueueSnackbar(intl.get('cases.details.messages.successMessage'), { variant: 'success' });
      });
    }
  };

  handleEdit = () => {
    this.setState({ isEditable: true });
  };

  handleQVFormChange = data => {
    this.formQVData = data;
  };

  toggleModal = status => {
    this.setState({
      showModal: status,
    });
  };

  checkActionBar = () => {
    const { headerDetails } = this.props;
    const isActionBarHidden =
      headerDetails && headerDetails.currentCaseStatus && headerDetails.currentCaseStatus === 'Closed' ? true : false;
    return isActionBarHidden;
  };

  createNewRecord = async event => {
    this.setState({ isLoading: true });
    let qvFormResult = null;
    const { setNewAdditionalInfoRecord, caseInfoData } = this.props;

    qvFormResult = await createQuickViewDetail({
      title: caseInfoData.case.title,
      caseId: caseInfoData.case.caseId,
      countryName: caseInfoData.case.serviceCountry,
      caseType: caseInfoData.case.eyService,
    });

    qvFormResult.case.caseId = caseInfoData.case.caseId;
    qvFormResult.case.pageElements.forEach(item => (item.numberOfColumns = item.numberOfColumns === null ? null : 2));
    setNewAdditionalInfoRecord(qvFormResult.case.createdId);

    this.props.updateAdditionalInfoData({
      isAdditionalInfoSecExist: true,
      hasAdditionalInfo: true,
      additionalInfoData: {
        countryMappingFormDetails: qvFormResult,
      },
    });

    this.setState({ isEditable: true, isLoading: false });
  };

  render() {
    const {
      isActive,
      isAdditionalInfoSecExist,
      hasAdditionalInfo,
      additionalInfoData,
      caseClosed,
      isCorpClient,
      isCorpClientLineManager,
      isCaseLoading,
    } = this.props;
    const wrapperFormDivClass = classNames({
      'detail-body-inner': true,
    });

    return (
      isActive &&
      isAdditionalInfoSecExist &&
      (hasAdditionalInfo ? (
        <CaseAdditionalInformationPres
          formDetails={additionalInfoData.countryMappingFormDetails}
          isActive={isActive}
          showModal={this.state.showModal}
          isEditable={this.state.isEditable}
          onCancel={this.toggleModal.bind(null, true)}
          onCancelModal={this.handleCancel}
          onConfirmModal={this.toggleModal.bind(null, false)}
          onSave={this.handleSave}
          onEdit={this.handleEdit}
          onFormChange={this.handleQVFormChange}
          isActionBarHidden={true}
          isCorpClient={isCorpClient || caseClosed}
          caseClosed={caseClosed}
          isLoading={this.state.isLoading || isCaseLoading}
          isCorpClientLineManager={isCorpClientLineManager}></CaseAdditionalInformationPres>
      ) : this.state.isLoading ? (
        <div style={{ marginTop: '10%' }}>
          <Spinner size={70} />
        </div>
      ) : (
        <div className={wrapperFormDivClass}>
          <Button className="action-button" onClick={this.createNewRecord}>
            {intl.get('cases.details.tabs.createAdditionalInformation')}
          </Button>
        </div>
      ))
    );
  }
}

export default withSnackbar(CaseAdditionalInformationContainer);
